import FormPhoneInput, { getCountryPhoneInfo } from './FormPhoneInput';

export default FormPhoneInput;

export { getCountryPhoneInfo };
